import { Breakpoint, Container, Stack, StackProps } from '@mui/material';
import { withErrorBoundary } from '@sentry/react';
import { mgprisPageHeight } from '@shared/styles';
import { ErrorFallbackPage } from '../ErrorFallback';

interface Props extends StackProps {
  maxWidth: Breakpoint | 'full';
  fixedHeight?: boolean;
}

export function PageLayout({ maxWidth, fixedHeight, children, sx, ...stackProps }: Props) {
  if (maxWidth === 'full') {
    return (
      <Stack
        component="main"
        sx={{
          height: fixedHeight ? mgprisPageHeight : undefined,
          p: 2,
          bgcolor: 'background.default',
          ...sx,
        }}
        {...stackProps}
      >
        {children}
      </Stack>
    );
  }

  return (
    <Container
      // @ts-ignore
      maxWidth={maxWidth}
      component="main"
      disableGutters={fixedHeight}
      sx={{
        ...(fixedHeight && {
          height: mgprisPageHeight,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }),
        ...sx,
      }}
      {...stackProps}
    >
      {children}
    </Container>
  );
}

export default withErrorBoundary(PageLayout, {
  fallback: (props) => <ErrorFallbackPage {...props} message={props.error.message} />,
});
